import { OSKIconDefinition } from '../osk-icon.types';
import { oskIconAlertCircle } from './osk-icon-alert-circle';
import { oskIconAlertTriangle } from './osk-icon-alert-triangle';
import { oskIconArrowDown } from './osk-icon-arrow-down';
import { oskIconArrowLeft } from './osk-icon-arrow-left';
import { oskIconArrowRight } from './osk-icon-arrow-right';
import { oskIconArrowUp } from './osk-icon-arrow-up';
import { oskIconCalendar } from './osk-icon-calendar';
import { oskIconCheck } from './osk-icon-check';
import { oskIconCheckCircle } from './osk-icon-check-circle';
import { oskIconChevronDown } from './osk-icon-chevron-down';
import { oskIconChevronLeft } from './osk-icon-chevron-left';
import { oskIconChevronRight } from './osk-icon-chevron-right';
import { oskIconChevronsUpDown } from './osk-icon-chevrons-up-down';
import { oskIconClock } from './osk-icon-clock';
import { oskIconCopy } from './osk-icon-copy';
import { oskIconEye } from './osk-icon-eye';
import { oskIconEyeOff } from './osk-icon-eye-off';
import { oskIconInfo } from './osk-icon-info';
import { oskIconMoreVertical } from './osk-icon-more-vertical';
import { oskIconRefresh } from './osk-icon-refresh';
import { oskIconSearch } from './osk-icon-search';
import { oskIconX } from './osk-icon-x';
import { oskIconXCircle } from './osk-icon-x-circle';

/** Icons used inside @oskey/ui components themselves; always registered. */
export const OSK_CORE_ICONS: readonly OSKIconDefinition[] = [
  oskIconAlertCircle,
  oskIconAlertTriangle,
  oskIconArrowDown,
  oskIconArrowLeft,
  oskIconArrowRight,
  oskIconArrowUp,
  oskIconCalendar,
  oskIconCheck,
  oskIconCheckCircle,
  oskIconChevronDown,
  oskIconChevronLeft,
  oskIconChevronRight,
  oskIconChevronsUpDown,
  oskIconClock,
  oskIconCopy,
  oskIconEye,
  oskIconEyeOff,
  oskIconInfo,
  oskIconMoreVertical,
  oskIconRefresh,
  oskIconSearch,
  oskIconX,
  oskIconXCircle
];
